<div class="row">
  <div class="col-12">
      <div class="content-header">Avatar</div>
      <p class="content-sub-header mb-1">  </p>
  </div>
</div>

<!-- Default Avatar Starts -->
<section id="avatar-default">
  <div class="row">
      <div class="col-12">
          <div class="card">
              <div class="card-header">
                  <h4 class="card-title">Default</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <p>Wrap your content with <code>.avatar</code> and wrap your text in <code>.avatar-content</code> to create a avatar. Use inline <code>attributes</code> to set height and width of an image in an avatar.</p>
                      <div class="avatar mr-2">
                          <span class="avatar-content"><i class="avatar-icon ft-github"></i></span>
                      </div>
                      <div class="avatar mr-2">
                          <span class="avatar-content">LD</span>
                      </div>
                      <div class="avatar mr-2">
                          <span class="avatar-content">John</span>
                      </div>
                      <div class="avatar">
                          <img src="assets/img/portrait/small/avatar-s-16.png" alt="avatar" height="32" width="32">
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- Default Avatar Ends -->

<!-- Sizes Avatar Starts -->
<section id="avatar-sizes">
  <div class="row">
      <div class="col-12">
          <div class="card">
              <div class="card-header">
                  <h4 class="card-title">Sizes</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <p>Use <code>.avatar-(sm | md | lg | xl)</code> to modify size of your avatar.</p>
                      <div class="avatar avatar-sm mr-2">
                          <span class="avatar-content"><i class="avatar-icon ft-github"></i></span>
                      </div>
                      <div class="avatar mr-2">
                          <span class="avatar-content">LD</span>
                      </div>
                      <div class="avatar avatar-md mr-2">
                          <img src="assets/img/portrait/small/avatar-s-16.png" alt="avatar">
                      </div>
                      <div class="avatar avatar-lg mr-2">
                          <img src="assets/img/portrait/small/avatar-s-16.png" alt="avatar">
                      </div>
                      <div class="avatar avatar-xl">
                          <img src="assets/img/portrait/small/avatar-s-16.png" alt="avatar">
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- Sizes Avatar Ends -->

<!-- Avatar Colors Starts-->
<section id="avatar-colors">
  <div class="row">
      <div class="col-12">
          <div class="card">
              <div class="card-header">
                  <h4 class="card-title">Colors</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <div class="row">
                          <div class="col-md-6 col-12 mb-3 mb-md-0">
                              <p>Use <code>.bg-(colorName)</code> to change background color of your avatar.</p>
                              <div class="avatar bg-primary mr-2">
                                  <div class="avatar-content">P</div>
                              </div>
                              <div class="avatar bg-success mr-2">
                                  <div class="avatar-content">S</div>
                              </div>
                              <div class="avatar bg-danger mr-2">
                                  <div class="avatar-content">D</div>
                              </div>
                              <div class="avatar bg-info mr-2">
                                  <div class="avatar-content">I</div>
                              </div>
                              <div class="avatar bg-warning">
                                  <div class="avatar-content">W</div>
                              </div>
                          </div>
                          <div class="col-md-6 col-12">
                              <p>Use <code>.bg-light-(colorName)</code> to change background color of your avatar.</p>
                              <div class="avatar bg-light-primary mr-2">
                                  <div class="avatar-content">P</div>
                              </div>
                              <div class="avatar bg-light-success mr-2">
                                  <div class="avatar-content">S</div>
                              </div>
                              <div class="avatar bg-light-danger mr-2">
                                  <div class="avatar-content">D</div>
                              </div>
                              <div class="avatar bg-light-info mr-2">
                                  <div class="avatar-content">I</div>
                              </div>
                              <div class="avatar bg-light-warning">
                                  <div class="avatar-content">W</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- Avatar Colors Ends -->

<!-- Avatar With Badge Starts -->
<section id="avatar-badge">
  <div class="row">
      <div class="col-12">
          <div class="card">
              <div class="card-header">
                  <h4 class="card-title">Avatar With Badge</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <p>You can add notification label to avatar by using <code>.badge</code></p>
                      <div class="avatar bg-primary mr-2">
                          <div class="avatar-content">
                              <i class="avatar-icon ft-facebook"></i>
                              <span class="badge badge-pill badge-round badge-danger">7</span>
                          </div>
                      </div>
                      <div class="avatar bg-info mr-2">
                          <div class="avatar-content">
                              <i class="avatar-icon ft-twitter"></i>
                              <span class="badge badge-pill badge-round badge-danger">5</span>
                          </div>
                      </div>
                      <div class="avatar bg-success">
                          <div class="avatar-content">
                              <i class="avatar-icon ft-instagram"></i>
                              <span class="badge badge-pill badge-round badge-danger">6</span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- Avatar With Badge Ends -->

<!-- Avatar Icons Starts -->
<section id="avatar-icons">
  <div class="row">
      <div class="col-12">
          <div class="card">
              <div class="card-header">
                  <h4 class="card-title">Icons</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <p>Use <code>i.avatar-icon</code> for an icon inside an avatar.</p>
                      <div class="avatar bg-info mr-2">
                          <div class="avatar-content">
                              <i class="avatar-icon ft-github"></i>
                          </div>
                      </div>
                      <div class="avatar bg-primary mr-2">
                          <div class="avatar-content">
                              <i class="avatar-icon ft-calendar"></i>
                          </div>
                      </div>
                      <div class="avatar bg-success mr-2">
                          <div class="avatar-content">
                              <i class="avatar-icon ft-mail"></i>
                          </div>
                      </div>
                      <div class="avatar bg-danger mr-2">
                          <div class="avatar-content">
                              <i class="avatar-icon ft-camera"></i>
                          </div>
                      </div>
                      <div class="avatar bg-warning">
                          <div class="avatar-content">
                              <i class="avatar-icon ft-award"></i>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- Avatar Icons Ends -->

<!-- Avatar Status Starts -->
<section id="avatar-status">
  <div class="row">
      <div class="col-12">
          <div class="card">
              <div class="card-header">
                  <h4 class="card-title">Status</h4>
              </div>
              <div class="card-content">
                  <div class="card-body">
                      <p>Use <code>.avatar-status-(online | offline | away | busy)</code> and wrap it in <code>.avatar-content</code> to create avatar with status.</p>
                      <div class="avatar bg-success bg-lighten-2 mr-2">
                          <span class="avatar-content"><i class="avatar-icon ft-github"></i></span>
                          <span class="avatar-status-online"></span>
                      </div>
                      <div class="avatar mr-2">
                          <span class="avatar-content">LD</span>
                          <span class="avatar-status-offline"></span>
                      </div>
                      <div class="avatar bg-warning bg-lighten-2 mr-2">
                          <span class="avatar-content">John</span>
                          <span class="avatar-status-away"></span>
                      </div>
                      <div class="avatar mr-2">
                          <img src="assets/img/portrait/small/avatar-s-16.png" alt="avtar img holder" width="32" height="32">
                          <span class="avatar-status-busy"></span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- Avatar Status Ends -->
